import {
  IconCalendarEvent,
  IconCash,
  IconChecklist,
  IconFileText,
  IconHome,
  IconListCheck,
  IconTool,
  IconUserPlus,
  IconWallet,
} from '@tabler/icons-react';

/**
 * Un pictogramme par famille d'action, pour que la ligne se lise d'un coup d'œil.
 * Les types non listés retombent sur l'icône neutre.
 */
const ICONS: Record<string, typeof IconHome> = {
  EXPENSE: IconCash,
  MONEY_TRANSFER: IconWallet,
  BANK_ACCOUNT: IconWallet,
  EVENT: IconCalendarEvent,
  TASK: IconListCheck,
  CHECKLIST: IconChecklist,
  PROJECT: IconTool,
  DOCUMENT: IconFileText,
  MEMBER: IconUserPlus,
};

export const journalTypeToIcon = (type: string): typeof IconHome => {
  const family = Object.keys(ICONS).find(key => type.includes(key));
  return family ? ICONS[family] : IconHome;
};
